import Str from "@supercharge/strings";

const formatDisplayName = (value) => {
  const splitCamelCaseToString = (s) => {
    return s
      .split(/(?=[A-Z])/)
      .map(function (p) {
        return p.charAt(0).toUpperCase() + p.slice(1);
      })
      .join(" ");
  };
  const humanize = (str) => {
    var i,
      frags = str.split("_");
    for (i = 0; i < frags.length; i++) {
      frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
    }
    return frags.join(" ");
  };
  if (Str(value).isCamel()) {
    return splitCamelCaseToString(value);
  }

  return humanize(value);
};

export const parseOpenApi = (openApi) => {
  let parsed = [
    { id: "1", name: "Unread" },
    { id: "2", name: "Threads" },
    {
      id: "3",
      name: "Chat Rooms",
      children: [
        { id: "c1", name: "General" },
        { id: "c2", name: "Random" },
        { id: "c3", name: "Open Source Projects" },
      ],
    },
    {
      id: "4",
      name: "Direct Messages",
      children: [
        { id: "d1", name: "Alice" },
        { id: "d2", name: "Bob" },
        { id: "d3", name: "Charlie" },
      ],
    },
  ];
  parsed = getDataTables(openApi);
  //console.log("PARSED:", parsed);
  return parsed;
};

const whiteList = [
  "activities",
  "activity_descriptions",
  "activity_rates",
  "allocations",
  "bank_accounts",
  "bank_transactions",
  "billable_clients",
  "billable_matters",
  "bills",
  "calendar_entries",
  "contacts",
  "credit_memos",
  "custom_field_sets",
  "custom_fields",
  "expense_categories",
  "groups",
  "interest_charges",
  "court_rules/jurisdictions", // should only be loaded on demand
  "line_items",
  "outstanding_client_balances",
  "log_entries",
  "court_rules/matter_dockets",
  "court_rules/service_types",
  "matter_stages",
  "matters",
  "notes",
  "clio_payments/payments",
  "practice_areas",
  "relationships",
  "reminders",
  "tasks",
  "trust_line_items",
  "users",
  "settings/billing",
];

const getDataTables = (openApi) => {
  const root = [
    {
      id: "root",
      name: "Clio Data tables",
      type: "root",
      description: "Root Node",
      children: [],
    },
  ];

  const keys = Object.keys(openApi.paths);
  for (let i = 0; i < keys.length; i++) {
    const path = keys[i];
    if (path.search("{.*}") === -1) {
      const name = path.replace(".json", "");
      const schema = openApi.paths[path].get?.responses[200]?.content[
        "application/json; charset=utf-8"
      ].schema.$ref.replace("#/", "");

      // console.log(name.split("/").length);
      // console.log(name.replace("/", "")); // logs all names - useful for updating whitelist
      if (schema !== undefined && whiteList.includes(name.replace("/", ""))) {
        //console.log("name", name);
        //console.log("schema", schema);
        // fix the previous child
        if (root[0].children.length > 0) {
          root[0].children[root[0].children.length - 1].isLastChild = false;
        }

        root[0].children.push({
          id: `${name}`,
          name: name.replace("/", ""),
          description: "Data table",
          displayName: formatDisplayName(name.replace("/", "")),
          type: "table",
          version: "1.0.0", // TODO: initial version -> may need to migrate versions from old configuration
          isLastChild: true,
          isSelected: false,
          schema,
          children: [], //process_schema(name.replace("/", ""), schema, openApi),
        });
      }
    }
  }

  return root;
};

export const process_schema = (name, schema, openApi) => {
  const split_schema = schema.split("/");

  const component = openApi[split_schema[0]][split_schema[1]][split_schema[2]];
  //console.log("component", component);
  if (component.properties) {
    return process_component_properties(name, component.properties.data, openApi);
  }
  if (component.allOf) {
    return process_allOf(name, component.allOf, openApi);
  }
};

export const process_allOf = (name, allOf, openApi, baseOnly) => {
  //console.log("allOf", allOf);

  const base_items = process_base(name, allOf[0].$ref.replace("#/", ""), openApi);
  const objects = process_objects(name, allOf[1].properties, openApi);
  if (baseOnly) {
    return base_items;
  }
  const all = base_items.concat(objects);
  // process isLastChild
  all.forEach((child, index) => {
    child.isLastChild = index === all.length - 1;
  });
  return all;
};

export const process_component_properties = (name, component, openApi) => {
  if (component.items) {
    return process_schema(name, component.items.$ref.replace("#/", ""), openApi);
  } else {
    return process_schema(name, component.$ref.replace("#/", ""), openApi);
  }
};

export const process_base = (name, base, openApi) => {
  const splitbase = base.split("/");
  const baseComponent = openApi[splitbase[0]][splitbase[1]][splitbase[2]];
  console.log("baseComponent", baseComponent);
  //console.log("baseComponent.properties", baseComponent.properties);
  let children = [];
  if (baseComponent.allOf) {
    children = children.concat(process_allOf(name, baseComponent.allOf, openApi, true));
    // process all children for isLastChild
    children.forEach((child, index) => {
      child.isLastChild = index === children.length - 1;
    });
  } else {
    const keys = Object.keys(baseComponent.properties);
    for (let i = 0; i < keys.length; i++) {
      const prop = keys[i];
      // console.log(
      //   "processing: ",
      //   `${name}-${splitbase[2]}-${prop}`,
      //   "prop",
      //   prop,
      //   "baseComponent.properties[prop]",
      //   baseComponent.properties[prop]
      // );
      const item = {
        id: `${name}-${splitbase[2]}-${prop}`, // need to make id unique
        name: prop,
        description: baseComponent.properties[prop]?.description,
        propType: baseComponent.properties[prop]?.type,
        isSelected: false,
        type: "field",
        isLastChild: i === keys.length - 1,
        children: [],
      };
      //console.log("item", item);
      children.push(item);
    }
  }
  return children;
};

export const process_objects = (name, objects, openApi) => {
  let children = [];
  //console.log("objects", objects);
  const keys = Object.keys(objects);
  for (let i = 0; i < keys.length; i++) {
    const obj = objects[keys[i]];
    if (obj.$ref !== undefined) {
      //console.log("object", obj);
      children.push({
        id: `${name}-${obj.$ref.replace("#/", "").split("/")[2]}-${keys[i]}`,
        name: keys[i],
        propType: "object",
        type: "object",
        description: obj.description,
        isLastChild: i === keys.length - 1,
        isSelected: false,
        children: process_base(`${name}-${keys[i]}`, obj.$ref.replace("#/", ""), openApi),
      });
    } else {
      //console.log("array", obj);
      children.push({
        id: `${name}-${obj.items.$ref.replace("#/", "").split("/")[2]}-${keys[i]}`,
        name: keys[i],
        propType: obj.type,
        type: "array",
        description: obj.description,
        isLastChild: i === keys.length - 1,
        isSelected: false,
        children: process_base(`${name}-${obj}`, obj.items.$ref.replace("#/", ""), openApi),
      });
    }
  }
  return children;
};
